// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"5cf07bb6","153":"bec63b8c","187":"972193aa","336":"29346c46","394":"a7c07362"}[chunkId] + ".chunk.css";
};